/* ==========================================================================
   TalkPoint Collection v2 — Filter-Top-Leiste
   ES5, self-contained. Filterung läuft über echte Links/Navigation
   (Shopify url_to_add / url_to_remove), JS ist reine Progressive Enhancement.
   ========================================================================== */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.getAttribute('data-tp-colv2-init')) return;
    root.setAttribute('data-tp-colv2-init', '1');

    var filtersBox = root.querySelector('[data-tp-colv2-filters]');
    var sheet = root.querySelector('[data-tp-colv2-sheet]');
    var sheetBody = root.querySelector('[data-tp-colv2-sheet-body]');
    var overlay = root.querySelector('[data-tp-colv2-overlay]');
    var trigger = root.querySelector('[data-tp-colv2-trigger]');

    // Ursprungsposition merken, um filtersBox nach dem Sheet wieder einzuhängen
    var homeParent = filtersBox ? filtersBox.parentNode : null;
    var homeAnchor = filtersBox ? filtersBox.nextSibling : null;

    // Arbeits-Parameter: gestaltete Auswahl, erst beim "Anwenden" navigieren
    var working = new URLSearchParams(window.location.search);

    function toggleParam(name, value, on) {
      var all = working.getAll(name);
      var idx = all.indexOf(value);
      if (on && idx === -1) {
        working.append(name, value);
      } else if (!on && idx !== -1) {
        var rest = [];
        for (var i = 0; i < all.length; i++) { if (all[i] !== value) rest.push(all[i]); }
        working.delete(name);
        for (var j = 0; j < rest.length; j++) { working.append(name, rest[j]); }
      }
      working.delete('page'); // bei Filteränderung zurück auf Seite 1
    }

    function applyWorking() {
      window.location.search = working.toString();
    }

    function isInSheet(el) {
      return sheet && sheet.contains(el);
    }

    /* ---------- Dropdown auf/zu ---------- */
    function closeAll(except) {
      var open = root.querySelectorAll('.tp-colv2-fil[data-open]');
      for (var i = 0; i < open.length; i++) {
        if (open[i] === except) continue;
        open[i].removeAttribute('data-open');
        var b = open[i].querySelector('[data-tp-fil-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    }

    function onToggleClick(e) {
      var btn = e.currentTarget;
      var group = btn.parentNode;
      var willOpen = !group.hasAttribute('data-open');
      // Im Sheet als Accordion (mehrere offen), sonst nur eins
      if (!isInSheet(btn)) closeAll(group);
      if (willOpen) {
        group.setAttribute('data-open', '1');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        group.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    var toggles = root.querySelectorAll('[data-tp-fil-toggle]');
    for (var t = 0; t < toggles.length; t++) {
      toggles[t].addEventListener('click', onToggleClick);
    }

    /* ---------- Mehrfachauswahl: lokal toggeln, erst "Anwenden" navigiert ---------- */
    function activeClassFor(opt) {
      return opt.classList.contains('tp-colv2-swatch') ? 'tp-colv2-swatch--active' : 'tp-colv2-opt--active';
    }
    function refreshGroup(group) {
      var checked = group.querySelectorAll('[data-tp-opt][data-checked]').length;
      if (checked > 0) group.setAttribute('data-active', '1');
      else group.removeAttribute('data-active');
      var badge = group.querySelector('.tp-colv2-fil__btn .tp-colv2-fil__count');
      var btn = group.querySelector('.tp-colv2-fil__btn');
      if (checked > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'tp-colv2-fil__count';
          btn.insertBefore(badge, btn.querySelector('.tp-colv2-fil__chevron'));
        }
        badge.textContent = checked;
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
      var footer = group.querySelector('[data-tp-fil-footer]');
      if (footer) footer.removeAttribute('hidden');
    }

    var opts = root.querySelectorAll('[data-tp-opt]');
    for (var o = 0; o < opts.length; o++) {
      opts[o].addEventListener('click', function (e) {
        var opt = e.currentTarget;
        if (opt.hasAttribute('data-disabled')) { e.preventDefault(); return; }
        e.preventDefault();
        var on = !opt.hasAttribute('data-checked');
        if (on) opt.setAttribute('data-checked', '');
        else opt.removeAttribute('data-checked');
        opt.classList.toggle(activeClassFor(opt), on);
        toggleParam(opt.getAttribute('data-name'), opt.getAttribute('data-value'), on);
        refreshGroup(opt.closest('.tp-colv2-fil'));
      });
    }

    var applies = root.querySelectorAll('[data-tp-fil-apply]');
    for (var a = 0; a < applies.length; a++) {
      applies[a].addEventListener('click', function (e) {
        e.preventDefault();
        applyWorking();
      });
    }

    /* ---------- Range-Slider über diskrete Listen-Werte (z. B. Speicher) ---------- */
    function initSlider(slider) {
      var name = slider.getAttribute('data-name');
      var unit = slider.getAttribute('data-unit') || '';
      var panel = slider.closest('.tp-colv2-fil__panel') || slider.parentNode;
      var list = panel.querySelector('[data-tp-slider-list]');
      if (!list) return;
      var allAnchors = [].slice.call(list.querySelectorAll('[data-tp-opt]'));
      // Nur tatsächlich lieferbare Werte (count > 0 oder aktiv) bestimmen die Slider-Spanne.
      var anchors = allAnchors.filter(function (a) {
        return !a.hasAttribute('data-disabled') || a.hasAttribute('data-checked');
      });
      // 0 oder 1 verfügbarer Wert -> Range-Slider ist sinnlos. Liste sichtbar lassen,
      // dort wird der vorhandene Wert klickbar und der Rest ausgegraut gezeigt.
      if (anchors.length < 2) return;
      anchors.sort(function (a, b) {
        return parseFloat(a.getAttribute('data-value')) - parseFloat(b.getAttribute('data-value'));
      });
      var values = anchors.map(function (a) { return a.getAttribute('data-value'); });
      var nums = values.map(function (v) { return parseFloat(v); });
      var N = values.length;
      if (N < 2) return; // Slider ohne Auswahl sinnlos -> Liste sichtbar lassen

      list.setAttribute('hidden', '');
      slider.removeAttribute('hidden');

      var lo = slider.querySelector('[data-tp-slider-thumb="lo"]');
      var hi = slider.querySelector('[data-tp-slider-thumb="hi"]');
      var fill = slider.querySelector('[data-tp-slider-fill]');
      var loLabel = slider.querySelector('[data-tp-slider-lo]');
      var hiLabel = slider.querySelector('[data-tp-slider-hi]');
      lo.max = N - 1;
      hi.max = N - 1;

      var checkedIdx = [];
      anchors.forEach(function (a, i) { if (a.hasAttribute('data-checked')) checkedIdx.push(i); });
      lo.value = checkedIdx.length ? checkedIdx[0] : 0;
      hi.value = checkedIdx.length ? checkedIdx[checkedIdx.length - 1] : N - 1;

      function fmt(n) {
        if (unit === 'GB' && n >= 1024) {
          var tb = n / 1024;
          return (tb % 1 === 0 ? tb : tb.toFixed(1)) + ' TB';
        }
        return n + (unit ? ' ' + unit : '');
      }
      function render() {
        var a = parseInt(lo.value, 10), b = parseInt(hi.value, 10);
        var pa = (a / (N - 1)) * 100, pb = (b / (N - 1)) * 100;
        fill.style.left = pa + '%';
        fill.style.width = (pb - pa) + '%';
        loLabel.textContent = fmt(nums[a]);
        hiLabel.textContent = fmt(nums[b]);
      }
      function commit() {
        var a = parseInt(lo.value, 10), b = parseInt(hi.value, 10);
        working.delete(name);
        anchors.forEach(function (an) {
          an.removeAttribute('data-checked');
          an.classList.remove('tp-colv2-opt--active');
        });
        if (!(a === 0 && b === N - 1)) {
          for (var i = a; i <= b; i++) {
            working.append(name, values[i]);
            anchors[i].setAttribute('data-checked', '');
            anchors[i].classList.add('tp-colv2-opt--active');
          }
        }
        working.delete('page');
        refreshGroup(slider.closest('.tp-colv2-fil'));
      }

      lo.addEventListener('input', function () {
        if (parseInt(lo.value, 10) > parseInt(hi.value, 10)) hi.value = lo.value;
        render();
      });
      hi.addEventListener('input', function () {
        if (parseInt(hi.value, 10) < parseInt(lo.value, 10)) lo.value = hi.value;
        render();
      });
      lo.addEventListener('change', commit);
      hi.addEventListener('change', commit);
      render();
    }

    var sliders = root.querySelectorAll('[data-tp-slider]');
    for (var sl = 0; sl < sliders.length; sl++) initSlider(sliders[sl]);

    // Klick außerhalb schließt Desktop-Dropdowns
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { closeAll(); return; }
      if (e.target.closest && e.target.closest('.tp-colv2-fil')) return;
      if (isInSheet(e.target)) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeSheet(); }
    });

    /* ---------- In-Panel-Suche (lange Listen) ---------- */
    var searches = root.querySelectorAll('[data-tp-fil-search]');
    for (var s = 0; s < searches.length; s++) {
      searches[s].addEventListener('input', function (e) {
        var q = e.target.value.toLowerCase().trim();
        var list = e.target.parentNode.querySelector('[data-tp-fil-list]');
        if (!list) return;
        var items = list.querySelectorAll('[data-tp-fil-item]');
        for (var i = 0; i < items.length; i++) {
          var label = (items[i].getAttribute('data-label') || '').toLowerCase();
          if (q === '' || label.indexOf(q) !== -1) {
            items[i].removeAttribute('hidden');
          } else {
            items[i].setAttribute('hidden', '');
          }
        }
      });
    }

    /* ---------- Preis-Range → Navigation ---------- */
    var priceForms = root.querySelectorAll('[data-tp-price-form]');
    for (var p = 0; p < priceForms.length; p++) {
      priceForms[p].addEventListener('submit', function (e) {
        e.preventDefault();
        applyPrice(e.currentTarget);
      });
    }
    function applyPrice(form) {
      var inputs = form.querySelectorAll('input[name]');
      for (var i = 0; i < inputs.length; i++) {
        var name = inputs[i].name;
        var val = (inputs[i].value || '').trim();
        if (val === '') { working.delete(name); }
        else { working.set(name, val); }
      }
      working.delete('page');
      applyWorking();
    }

    /* ---------- Sort ---------- */
    var sortSel = root.querySelector('[data-tp-colv2-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        working.set('sort_by', this.value);
        working.delete('page');
        applyWorking();
      });
    }

    /* ---------- Mobile-Sheet ---------- */
    function openSheet() {
      if (!sheet || !sheetBody || !filtersBox) return;
      sheetBody.appendChild(filtersBox);
      closeAll(); // im Sheet starten alle Gruppen zu
      sheet.setAttribute('data-open', '1');
      if (overlay) overlay.setAttribute('data-open', '1');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.removeAttribute('data-open');
      if (overlay) overlay.removeAttribute('data-open');
      document.documentElement.style.overflow = '';
      // filtersBox zurück an Ursprungsposition
      if (filtersBox && homeParent && !homeParent.contains(filtersBox)) {
        if (homeAnchor && homeAnchor.parentNode === homeParent) {
          homeParent.insertBefore(filtersBox, homeAnchor);
        } else {
          homeParent.appendChild(filtersBox);
        }
      }
    }

    if (trigger) trigger.addEventListener('click', openSheet);
    if (overlay) overlay.addEventListener('click', closeSheet);

    // Mobile "Artikel anzeigen": gestaltete Auswahl anwenden, sonst nur schließen
    var applyBtn = root.querySelector('[data-tp-colv2-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var current = new URLSearchParams(window.location.search).toString();
        if (working.toString() !== current) applyWorking();
        else closeSheet();
      });
    }
    var closers = root.querySelectorAll('[data-tp-colv2-sheet-close]');
    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', closeSheet);
    }

    // Beim Wechsel auf Desktop Sheet sauber schließen
    var mq = window.matchMedia('(min-width: 750px)');
    var onMq = function (m) { if (m.matches) closeSheet(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-tp-colv2]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify Theme-Editor: Sections können neu geladen werden
  document.addEventListener('shopify:section:load', initAll);
})();
